import { clientFrontendUri } from './env'

export const PATH_HELPERS = {
  homebotForChromeSync: {
    buildPath: () => {
      return `${clientFrontendUri}/homebot-for-chrome`
    },
  },
}
